<div class="visitor-registration-masterdata">
    <sc-padding>
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>
            <ng-container [formGroup]="masterdataForm">


                <mat-form-field>
                    <input matInput name="name" formControlName="name"
                        placeholder="{{'Name' | translate: ['tmc-yard.entity.visit.name', translationService.language]}}"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="firstname" formControlName="firstname"
                        placeholder="{{'Firstname' | translate: ['tmc-yard.entity.visit.firstname', translationService.language]}}"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="company" formControlName="company"
                        placeholder="{{'Company' | translate: ['tmc-yard.entity.visit.company', translationService.language]}}"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                  <input matInput name="reasonForVisit" formControlName="reasonForVisit"
                      placeholder="{{'Reason' | translate: ['tmc-yard.entity.visit.reason', translationService.language]}}"
                      [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                  <input matInput name="visitedPerson" formControlName="visitedPerson"
                      placeholder="{{'Reason' | translate: ['tmc-yard.entity.visit.visited-person', translationService.language]}}"
                      [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                 <!-- <mat-form-field>
                  <input matInput name="numberplate" formControlName="numberplate"
                      placeholder="{{'numberplate' | translate: ['tmc-yard.entity.visit.numberplate', translationService.language]}}"
                      [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field> -->
                <app-numberplate-input [formGroup]="masterdataForm" formControlName="numberplate"
                                        minLengthInput="row.minLength"
                                        labelCheckbox="tmc-yard.entity.visit.no-vehicle" labelInput="tmc-yard.entity.visit.numberplate"></app-numberplate-input>

                <div class="checkbox">
                  <mat-checkbox formControlName="entranceBarrierSecuredAreaNeeded">
                    {{'Entrance Barrier secured arrea needed' | translate: ['tmc-yard.entity.visit.entranceBarrierSecuredAreaNeeded', translationService.language]}}
                  </mat-checkbox>
                </div>

            </ng-container>
            <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>
        </sc-flex>
    </sc-padding>
</div>
